/* eslint-disable camelcase */
import axios from 'axios'
import config from '../../config'

const instance = axios.create({
  withCredentials: false
})

type CreditCard = {
  number: string
  holderName: string
  expMonth: string
  expYear: string
  cvv: string
}

type CardInfo = {
  first_six_digits: string;
  last_four_digits: string;
  holder_name: string;
  exp_month: number;
  exp_year: number;
  brand: string;
}

export type CardTokenizerResponse = {
  id: string;
  type: string;
  created_at: Date;
  expires_at: Date;
  card: CardInfo;
}

export const cardTokenizer = async (creditCard: CreditCard): Promise<CardTokenizerResponse> => {
  const { data: result } = await instance.post<CardTokenizerResponse>('https://api.mundipagg.com/core/v1/tokens', {
    type: 'card',
    card: {
      number: creditCard.number,
      holder_name: creditCard.holderName,
      exp_month: creditCard.expMonth,
      exp_year: creditCard.expYear,
      cvv: creditCard.cvv
    }
  }, {
    params: { appId: config.MUNDIPAGG_PK },
    withCredentials: false
  })

  return result
}
